const digitalData = [
  {
    card1: '/assets/Von-digital5.jpg',
    card1Text: 'Advertisement for Midea',
    card2: '/assets/Von-digital6.jpg',
    card2Text: 'Advertisement for Adapts Media',
    card3: '/assets/Von-digital7.jpg',
    card3Text: 'Static posts for Advertisers.Store',
    card4: '/assets/Von-digital8.jpg',
    card4Text: 'Advertisement for Adapts Media',
    video7: '/assets/Von-motion5.mp4',
    title7: 'Web advertisement for Pepsi',
    video8: '/assets/Von-motion11.mp4',
    title8: 'Web advertisement for Cartier',
  }
]

export default digitalData;
